import React from 'react';
export var Pager = function Pager(_ref) {
  var isFetching = _ref.isFetching,
    totalPages = _ref.totalPages,
    pageIndex = _ref.pageIndex,
    currentPage = _ref.currentPage,
    setCurrentPage = _ref.setCurrentPage;
  return !isFetching && totalPages > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "mt-6 mr-6 flex justify-end items-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "mr-4 text-text-blue"
  }, "Page", ' ', /*#__PURE__*/React.createElement("strong", {
    className: "text-text-blue"
  }, pageIndex != null ? pageIndex : currentPage, " of ", totalPages), ' '), /*#__PURE__*/React.createElement("button", {
    id: "table-btn",
    "data-test-element": "table-btn",
    onClick: function onClick() {
      return setCurrentPage(1);
    },
    disabled: currentPage === 1,
    className: "h-10 w-16 text-action-blue bg-white border border-dark-border-blue rounded-sm disabled:opacity-50"
  }, "First"), /*#__PURE__*/React.createElement("button", {
    id: "forward-btn",
    "data-test-element": "forward-btn",
    onClick: function onClick() {
      setCurrentPage(function (s) {
        return s === 0 ? 0 : s - 1;
      });
    },
    disabled: currentPage === 1,
    className: "h-10 w-10 text-action-blue bg-white border border-dark-border-blue rounded-sm disabled:opacity-50"
  }, '<'), /*#__PURE__*/React.createElement("button", {
    id: "backward-btn",
    "data-test-element": "backward-btn",
    onClick: function onClick() {
      setCurrentPage(function (s) {
        return s + 1;
      });
    },
    disabled: currentPage === totalPages,
    className: "h-10 w-10 text-action-blue bg-white border border-dark-border-blue rounded-sm disabled:opacity-50"
  }, '>'), /*#__PURE__*/React.createElement("button", {
    id: "last-btn",
    "data-test-element": "last-btn",
    onClick: function onClick() {
      setCurrentPage(totalPages);
    },
    disabled: currentPage === totalPages,
    className: "h-10 w-16 text-action-blue bg-white border border-dark-border-blue rounded-sm disabled:opacity-50"
  }, "Last")), /*#__PURE__*/React.createElement("br", null));
};
//# sourceMappingURL=Pager.js.map